import React from 'react'
import { Router } from 'react-router-dom'
import { Provider as Redux, connect } from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import { setLocation } from '../../common/app/actions'

import App from './App'

class RouterComponent extends React.Component {
  componentWillMount() {
    const { setLocation } = this.props
    this.history = createHistory()
    this.unlisten = this.history.listen(({ pathname }) => {
      setLocation([pathname])
    })
  }
  componentWillUnmount() {
    this.unlisten()
  }
  render() {
    return (
      <Router history={this.history}>
        <App />
      </Router>
    )
  }
}

RouterComponent.propTypes = {
  setLocation: React.PropTypes.func.isRequired,
}

const ConnectedRouter = connect(() => ({}), { setLocation })(RouterComponent)

type Props = {
  store: Object,
}

class Root extends React.Component { // eslint-disable-line
  props: Props

  render() {
    const { store } = this.props
    return (
      <Redux store={store}>
        <ConnectedRouter />
      </Redux>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/browser/app/Root.js